export default __webpack_public_path__ + "13c50883b34b9a6a5c5a859c2b9bdd0d.png";